<template>
  <label :for="id" class="inline-flex items-center">
    <input
      type="radio"
      :value="value"
      :id="id"
      :name="name"
      :disabled="disabled"
      v-model="proxyChecked"
      class="
        peer
        disabled:opacity-50
        form-radio
        border-2 border-gray-500
        hover:bg-disabled
        focus:border-selected
        focus:bg-white
        checked:bg-white
        checked:border-gray-800
      "
    />
    <span class="ml-2 peer-disabled:opacity-50">{{ label }}</span>
  </label>
</template>

<script>
export default {
  emits: ["update:checked"],

  props: {
    checked: {
      type: [Array, Boolean],
      default: false,
    },
    value: {
      default: null,
    },
    id: String,
    label: String,
    name: String,
    disabled: {
        type: Boolean,
        default: false
    },
  },

  computed: {
    proxyChecked: {
      get() {
        return this.checked;
      },

      set(val) {
        this.$emit("update:checked", val);
      },
    },
  },
};
</script>